import {useState} from "react";
import {BiDownArrow} from "react-icons/bi";
import {AnimatePresence, motion} from "framer-motion";
import {useParams} from "react-router-dom";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import FormButton from "../../../../components/Form/Button/FormButton";
import FormItem from "../../../../components/Form/FormItem/FormItem";
import axiosInstance from "../../../../API/Axios/AxiosConfig";
import URLS from "../../../../API/Axios/URLS";
import {toast} from "react-toastify";


export function AnswerEmptyDropDown({
                                        className,
                                        headerTitle,
                                        headerSubTitle,
                                        possibleAnswers,
                                        justifications,

                                        ...props
                                    }) {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <div className={`${className} flex flex-1 flex-col overflow-hidden`}>
            <button
                onClick={() => setIsOpen((prev) => !prev)}
                className={`flex-1 flex items-center justify-between py-2 text-white font-md
                    bg-tertiary-900
                    ${isOpen ? "rounded-t-md" : "rounded-md"}
                    `}>
                <p className={"font-semibold text-base px-2"}>
                    {headerTitle}{"  "}
                    <span className={"font-normal ml-2 text-base"}>{headerSubTitle}</span>
                </p>
                <div className={"px-2"}>
                    {isOpen ?
                        <BiDownArrow className={"text-white animate transform rotate-180"}/>
                        :
                        <BiDownArrow className={"text-white"}/>

                    }
                </div>
            </button>

            {
                isOpen &&
                <AnimatePresence>

                    <motion.div
                        style={{overflow: "hidden"}}
                        initial={{height: 0}}
                        animate={{height: "auto"}}
                        transition={{duration: 0.1}}
                        exit={{height: 0}}
                        key={"container"}
                        className={"text-primary-600 bg-tertiary-100 p-2 border border-tertiary-900 rounded-b-lg text-sm lg:text-base"}>
                        {isOpen && <div>
                            {
                                props?.children
                            }
                        </div>
                        }
                    </motion.div>
                </AnimatePresence>
            }


        </div>

    )
}

function EditingPage({justifications}) {
    const [answer, setAnswer] = useState(justifications);
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)
    const {id} = useParams();

    function saveAnswer() {
        setIsLoaded(true)
        setError(null)
        axiosInstance.post(URLS.UpdateQuestion, {
            question: id,
            answer: answer
        }).then((res) => {
            toast.success("Answer Saved", {
                toastId: "answer-saved"
            })
        }).catch((e) => {
            setError(e?.response?.message || e?.response?.data?.message || "something went wrong")
        }).finally(() => {
            setIsLoaded(false)
        })
    }


    return (
        <div className={"w-full flex flex-col gap-2"}>

            <textarea
                value={answer}
                autoFocus={true}
                className={"w-full h-32 rounded-lg border-[1.5px] text-black-2 dark:text-white border-b-gray dark  py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter "}
                onChange={(e) => setAnswer(e.target.value)}
            />

            <p className={"text-red-500 ml-2"}>
                {error}
            </p>

            <div className={"w-full flex justify-end items-end"}>
                <FormButton
                    loading={isLoaded}
                    onClick={saveAnswer}
                    className={"h-[40px] max-w-[250px]"}
                >
                    Save
                </FormButton>
            </div>


        </div>
    )
}

export default function AnswerDropDown({
                                           className,
                                           headerTitle,
                                           headerSubTitle,
                                           possibleAnswers,
                                           justifications,
                                           justifications2,
                                           allowEditing,
                                           ...props
                                       }) {
    const [isOpen, setIsOpen] = useState(false)
    const {authActions} = useSession();

    const isEditingAllowed = allowEditing && authActions.is_admin() && allowEditing;


    return (
        <div className={`${className} flex flex-1 flex-col overflow-hidden`}>
            <button
                onClick={() => setIsOpen((prev) => !prev)}
                className={`flex-1 flex items-center justify-between py-2 text-white font-md
                    bg-tertiary-900
                    ${isOpen ? "rounded-t-md" : "rounded-md"}
                    `}>
                <p className={"font-semibold text-base px-2"}>
                    {headerTitle}{"  "}
                    <span className={"font-normal ml-2 text-base"}>{headerSubTitle}</span>
                </p>
                <div className={"px-2"}>
                    {isOpen ?
                        <BiDownArrow className={"text-white animate transform rotate-180"}/>
                        :
                        <BiDownArrow className={"text-white"}/>

                    }
                </div>
            </button>

            {
                isOpen &&
                <AnimatePresence>

                    <motion.div
                        style={{overflow: "hidden"}}
                        initial={{height: 0}}
                        animate={{height: "auto"}}
                        transition={{duration: 0.1}}
                        exit={{height: 0}}
                        key={"container"}
                        className={"text-primary-600 bg-tertiary-100 p-2 border border-tertiary-900 rounded-b-lg text-sm lg:text-base"}>
                        {isOpen ? <>
                            <div className={"gap-2"}>
                                <p className={"font-bold"}>
                                    {possibleAnswers}
                                </p>
                                {isEditingAllowed ? <EditingPage
                                    justifications={justifications}
                                /> : <p>
                                    1. {justifications}
                                </p>}
                            </div>
                            {justifications2 && <div className={"gap-2 mt-3"}>
                                <p className={"font-bold"}>
                                    {possibleAnswers}
                                </p>
                                {isEditingAllowed ? <EditingPage
                                    justifications={justifications2}
                                /> : <p>
                                    2. {justifications2}
                                </p>}
                            </div>
                            }

                        </> : ""
                        }
                    </motion.div>
                </AnimatePresence>
            }


        </div>

    )
}